export default __webpack_public_path__ + "static/media/salesforce.e3d14b62.png";